import "./DashedProgressBar.scss";

export const DashedProgressBar = ({ current, total, color = "#22c55e", bgColor = "#232323" }) => {
  const percentage = (current / total) * 100;

  return (
    <div className="dashed-progress-bar">
      <div
        className="dashed-progress-bar__bar"
        style={{ background: `repeating-linear-gradient(90deg, ${bgColor} 0, ${bgColor} 2px, transparent 2px, transparent 4px)` }}
      >
        <div
          className="dashed-progress-bar__fill"
          style={{
            width: `${percentage}%`,
            background: `repeating-linear-gradient(90deg, ${color} 0, ${color} 2px, transparent 2px, transparent 4px)`
          }}
        ></div>
      </div>
    </div>
  );
};
